/* This example requires Tailwind CSS v2.0+ */

import React from "react"
/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from "react"
import { Popover, Transition } from "@headlessui/react"
import { MenuIcon, XIcon } from "@heroicons/react/outline"
import washLogo from "../images/washLogo.png"

export default function Navbar() {
  return (
    <Popover className="z-10 relative bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 md:space-x-10 md:pr-10">
          <div className="flex justify-start lg:w-0 lg:flex-1">
            <a href="/">
              <span className="sr-only">Workflow</span>
              <img className="h-28 w-auto" src={washLogo} alt="" />
            </a>
          </div>
          <div className="-mr-2 -my-2 md:hidden">
            <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
              <span className="sr-only">Open menu</span>
              <MenuIcon className="h-10 w-10" aria-hidden="true" />
            </Popover.Button>
          </div>
          <Popover.Group as="nav" className="hidden md:flex space-x-10">
            <a
              href="/curriculum"
              className="text-base inline-flex items-center font-medium text-gray-500 hover:text-gray-900"
            >
              Curriculum
            </a>
            <a
              href="/resources"
              className="text-base inline-flex items-center font-medium text-gray-500 hover:text-gray-900"
            >
              Resources
            </a>
            <a
              href="/services"
              className="text-base inline-flex items-center font-medium text-gray-500 hover:text-gray-900"
            >
              Services
            </a>
            <a
              href="https://www.google.com/url?q=https://docs.google.com/forms/d/e/1FAIpQLScUpuMuYd4tVZD4wD8NKpiTERRKpJPTr6BN8FpO6HvObw-Diw/viewform&sa=D&source=docs&ust=1651064407068977&usg=AOvVaw0SZS6o-NA-Nr36jtS-0qpc"
              target="_blank"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-[#004fff] hover:bg-blue-700"
            >
              Book a Consultation
            </a>
          </Popover.Group>
        </div>
      </div>

      <Transition
        as={Fragment}
        enter="duration-200 ease-out"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Popover.Panel
          focus
          className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
        >
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
            <div className="pt-5 pb-6 px-5">
              <div className="flex items-center justify-between">
                <div>
                  <img className="h-28 w-auto" src={washLogo} alt="Workflow" />
                </div>
                <div className="-mr-2">
                  <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span className="sr-only">Close menu</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
              </div>
              <div className="mt-6"></div>
            </div>
            <div className="py-6 px-5 space-y-6">
              <div className="grid grid-cols-1 gap-y-4 gap-x-8">
                <a
                  href="/curriculum"
                  className="text-base font-medium text-gray-900 hover:text-gray-700"
                >
                  Curriculum
                </a>

                <a
                  href="/resources"
                  className="text-base font-medium text-gray-900 hover:text-gray-700"
                >
                  Resources
                </a>
                <a
                  href="/services"
                  className="text-base font-medium text-gray-900 hover:text-gray-700"
                >
                  Services
                </a>
                <a
                  href="https://www.google.com/url?q=https://docs.google.com/forms/d/e/1FAIpQLScUpuMuYd4tVZD4wD8NKpiTERRKpJPTr6BN8FpO6HvObw-Diw/viewform&sa=D&source=docs&ust=1651064407068977&usg=AOvVaw0SZS6o-NA-Nr36jtS-0qpc"
                  target="_blank"
                  className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-[#004fff] hover:bg-blue-700 w-2/4"
                >
                  Book a Consultation
                </a>
              </div>
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  )
}
